import { render, staticRenderFns } from "./ButtonSubmit.vue?vue&type=template&id=12e8635f&scoped=true"
import script from "./ButtonSubmit.vue?vue&type=script&lang=js"
export * from "./ButtonSubmit.vue?vue&type=script&lang=js"
import style0 from "./ButtonSubmit.vue?vue&type=style&index=0&id=12e8635f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e8635f",
  null
  
)

export default component.exports